// extracted by mini-css-extract-plugin
module.exports = {"logo":"style_logo__12Bkb","logo__small":"style_logo__small__1py1P"};